// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"color-invert"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 21.1066V3L6.6967 8.3033C3.76777 11.2322 3.76777 15.981 6.6967 18.9099C8.16117 20.3744 10.0806 21.1066 12 21.1066Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M12 21.1066V3L17.3033 8.3033C20.2322 11.2322 20.2322 15.981 17.3033 18.9099C15.8388 20.3744 13.9194 21.1066 12 21.1066Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 20V4","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 21C14.0474 21 15.5 20.5905 17.3033 18.9099M17.3033 18.9099C20.2888 16.1275 20 11 17.3033 8.3033M17.3033 18.9099C20.2322 15.981 20.2322 11.2322 17.3033 8.3033M17.3033 18.9099C14.3744 21.8388 9.62563 21.8388 6.6967 18.9099C3.76777 15.981 3.76777 11.2322 6.6967 8.3033L12 3L17.3033 8.3033","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-color-invert')
export default class ColorInvertIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'color-invert',
    }
  }
}
